(function () {
  var STYLE_ID = "rivo-referral-theme-styles";
  var FONT_ID = "rivo-referral-theme-fonts";
  var cssUrl = window.rivoReferralThemeCssUrl;
  var cachedCss = "";

  if (!cssUrl) return;

  function addFonts(doc) {
    if (doc.getElementById(FONT_ID)) return;

    var link = doc.createElement("link");
    link.id = FONT_ID;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;1,400&family=Work+Sans:wght@400&display=swap";
    doc.head.appendChild(link);
  }

  function addStyles(doc, css) {
    var style = doc.getElementById(STYLE_ID);
    if (!style) {
      style = doc.createElement("style");
      style.id = STYLE_ID;
      doc.head.appendChild(style);
    }
    style.textContent = css;
  }

  function styleIframe(iframe) {
    try {
      var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
      if (!doc || !doc.head) return;

      addFonts(doc);
      addStyles(doc, cachedCss.replace(/#rivo-lp-referral-campaign\s+/g, ""));
    } catch (error) {
      /* Cross-origin iframe; styles cannot be injected. */
    }
  }

  function styleAllIframes() {
    if (!cachedCss) return;

    document
      .querySelectorAll("#rivo-lp-referral-campaign iframe, iframe.rivo-referral")
      .forEach(styleIframe);
  }

  function startWatching() {
    styleAllIframes();

    var observer = new MutationObserver(styleAllIframes);
    observer.observe(document.body, { childList: true, subtree: true });

    var attempts = 0;
    var timer = setInterval(function () {
      styleAllIframes();
      attempts += 1;
      if (attempts >= 40) clearInterval(timer);
    }, 250);
  }

  fetch(cssUrl)
    .then(function (response) {
      return response.text();
    })
    .then(function (css) {
      cachedCss = css;
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", startWatching);
      } else {
        startWatching();
      }
    });
})();
